import {
  SET_DIRECTIONS,
  SET_DIRECTION_FLAG,
  SWITCH_DEPARTURE_ARRIVAL,
} from './types/PostalOperatorActionTypes';

export function setDirections(payload) {
  return {
    type: SET_DIRECTIONS,
    payload,
  };
}

export function setDirectionFlag(payload) {
  return {
    type: SET_DIRECTION_FLAG,
    payload,
  };
}

export function switchDepartureArrival(payload) {
  return {
    type: SWITCH_DEPARTURE_ARRIVAL,
    payload,
  };
}
